import React from 'react';
import { Section } from './ui/Section';
export function ForWhomSection() {
  return <Section background="cream" data-id="element-55">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-56">
        <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-terracotta" data-id="element-57">
          <h3 className="text-2xl font-serif font-bold text-warm-dark mb-6" data-id="element-58">
            Esto es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-59">
            <ListItem text="Tienes 35+ años y sientes que tu cuerpo cambió." data-id="element-60" />
            <ListItem text="Sientes que el día se te rompe en la tarde/noche." data-id="element-61" />
            <ListItem text="Quieres bajar de peso sin obsesión ni dietas extremas." data-id="element-62" />
            <ListItem text="Buscas reglas simples que se sostengan con tu vida real." data-id="element-63" />
          </ul>
        </div>

        <div className="bg-warm-gray/10 p-8 rounded-2xl border-t-4 border-warm-gray" data-id="element-64">
          <h3 className="text-2xl font-serif font-bold text-warm-dark mb-6" data-id="element-65">
            No es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-66">
            <ListItem text="Buscas resultados mágicos en 2 días." cross data-id="element-67" />
            <ListItem text="Quieres una dieta clínica personalizada." cross data-id="element-68" />
            <ListItem text="Tienes un trastorno alimenticio activo (mereces apoyo profesional)." cross data-id="element-69" />
            <ListItem text="Buscas contar macros y pesar cada gramo." cross data-id="element-70" />
          </ul>
        </div>
      </div>
    </Section>;
}
function ListItem({
  text,
  cross = false
}: {
  text: string;
  cross?: boolean;
}) {
  return <li className="flex items-start" data-id="element-71">
      <span className={`mr-3 text-xl ${cross ? 'text-warm-gray' : 'text-terracotta'}`} data-id="element-72">
        {cross ? '×' : '✓'}
      </span>
      <span className="text-warm-dark" data-id="element-73">{text}</span>
    </li>;
}